export { PartnerAgreementCard } from "./partner-agreement-card";
